/** @jsx jsx */

import { jsx } from '@emotion/core';
import { useCachedResource } from 'services/useCachedResource';
import { CHAMELEON_CACHE_v1 } from 'services/imageCache';

const Background = ({
  backgroundImage,
  backgroundImageOpacity,
  backgroundBlur = 0,
}) => {
  const backgroundImageURL = backgroundImage
    .split(/\(|\)/g)[1]
    .replace(/'/g, '');

  const cachedBackgroundImage = useCachedResource(
    CHAMELEON_CACHE_v1,
    backgroundImageURL
  );

  return (
    <div
      style={{
        position: 'absolute',
        left: 0,
        top: 0,
        width: '100%',
        height: '100%',
        overflow: 'hidden',
      }}
    >
      <div
        style={{
          width: 'inherit',
          height: 'inherit',
          background: `url('${cachedBackgroundImage ||
            backgroundImageURL}') center / cover no-repeat`,
          opacity: backgroundImageOpacity / 100,
          filter: `blur(${backgroundBlur}px)`,
          // scale the thing up to not have blurry edges
          ...(backgroundBlur > 0 && {
            transformOrigin: 'center',
            transform: 'scale(1.1)',
          }),
        }}
      />
    </div>
  );
};

export default Background;
